import { openDB } from 'idb';

export async function clearResourcesCache() {
    localStorage.setItem('casinoStale', '1');
    localStorage.removeItem('metadata');
    localStorage.removeItem('metadataV');
    localStorage.removeItem('casino');
    localStorage.removeItem('casinoVersion');

    try {
        const db = await openDB('MyDatabase', 23);
        await db.delete('betting', 'metadata');
        await db.delete('betting', 'metadataV');
        await db.delete('betting', 'casino');
        await db.delete('betting', 'casinoVersion');
    } catch (err) {
        console.warn('Failed to clear IndexedDB', err);
    }
}
